/// <reference types="vite/client" />

export const env = {
    orgServer: import.meta.env.VITE_ORG_SERVER,
    orgClient: import.meta.env.VITE_ORG_CLIENT,
};